export default "__VITE_ASSET__Dbba21F___"